//
//
//
//


export default {
  props: {
    value: String
  }
}
